<template>
    <div>
      <OnboardingIndex
        :title="title"
        :submit_button_text="submit_button_text"
        :verification_running="verification_running"
        :show_back_button="true"
        @custom-submit="sign_up_function"
      >
        <template v-slot:form-content>
          <div class="row g-2">
            <div>
              <label for="first_name" class="text-xs">First Name</label>
              <input
                type="text"
                class="form-control form-control-sm text-xxs bg-light py-2 pe-2 border-0"
                v-model="first_name"
                id="first_name"
                placeholder="Enter your first name"
                required
              />
            </div>
            <div>
              <label for="last_name" class="text-xs">Last Name</label>
              <input
                type="text"
                class="form-control form-control-sm text-xxs bg-light py-2 pe-2 border-0"
                v-model="last_name"
                id="last_name"
                placeholder="Enter your last name"
                required
              />
            </div>
          </div>

          <div class="mb-0">
            <label for="email" class="text-xs">Email</label>
            <input
              type="text"
              class="form-control form-control-sm text-xxs  bg-light py-2 pe-2 border-0"
              v-model="email"
              placeholder="Enter your email address"
              required
            />
          </div>

          <div class="mb-0">
            <label for="cell_number" class="text-xs">Phone Number</label>
            <input
              type="text"
              class="form-control form-control-sm text-xxs bg-light py-2 pe-2 border-0"
              v-model="phone_number"
              maxlength="10"
              @keypress="validate_numbers"
              oninput="this.value = this.value.replace(/\D/g, '')"
              placeholder="Enter your phone number"
              required
            />
              <small
                v-if="phone_number && !validate_phone_number(phone_number)"
                class="text-danger p-2 text-xxs fw-bold d-block"
              >
                Please enter a valid 10-digit phone number
              </small>
              <small
                v-else
                class="text-danger p-2 text-xxs fw-bold d-none"
              >
              Please enter a valid phone number
              </small>
          </div>
          <!-- New Password Field -->
          <div class="mb-0 position-relative">
            <label for="password" class="text-xs">New Password</label>
            <input
              :type="show_password ? 'text' : 'password'"
              class="form-control password form-control-sm text-xxs bg-light py-2 pe-2 border-0"
              v-model="password"
              id="password"
              placeholder="Enter your password"
              required
            />
            <i
              :class="show_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
              class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
              @click="toggle_password_visibility"
            ></i>
          </div>

          <!-- Confirm Password Field -->
          <div class="mb-2 position-relative">
            <label class="text-xs ">Confirm password</label>
            <input
              :type="show_confirm_password ? 'text' : 'password'"
              class="form-control password form-control-sm text-xxs bg-light py-2 pe-2 border-0"
              v-model="confirm_password"
              id="confirm_password"
              placeholder="Confirm your password"
              required
            />
            <i
              :class="show_confirm_password ? 'bi bi-eye' : 'bi bi-eye-slash'"
              class="position-absolute end-0 top-50 translate-middle-y-eye me-3 text-secondary cursor-pointer z-2"
              @click="toggle_confirm_password_visibility"
            ></i>
          </div>
        </template>

        <!-- Signup-specific elements -->
        <template v-slot:signup-content>
          <p class="mb-0 p-0 m-0 text-xs">
            Already have an account?
            <a href="/login" class="text-primary text-decoration-none fw-bold">Login here</a>
          </p>
        </template>
      </OnboardingIndex>

    </div>
  </template>

